import { ID, TaskListTreeItem } from '@griply/types';

import { sortItems } from '../../sort-items';

// List order holds one position per goal; a goal under several parents needs one per parent.
export const orderGoalTreeChildren = (
  treeItems: Record<ID, TaskListTreeItem>,
  goalChildrenByParentId: Map<ID, ID[]> | undefined,
): void => {
  goalChildrenByParentId?.forEach((order, parentId) => {
    const parent = treeItems[parentId];
    if (!parent?.children?.length) {
      return;
    }
    parent.children = sortItems(
      parent.children.map((id) => ({ id })),
      order,
      'id',
    ).map(({ id }) => id);
  });
};
